import Button, {BtnColor} from "../../../components/Button/Button";
import {Link} from "react-router-dom";
import EmulatorMainScreen from "../../../components/EmulatorMainScreen/EmulatorMainScreen";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import EmulatorSplashScreen from "../../../components/EmulatorSplashScreen/EmulatorSplashScreen";
import {onAppSubmit} from "../../../store/App/actions";
import Loading from "../../../components/Loading";
import {useTranslation} from "react-i18next";

const Step4 = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const { splash, loading } = useSelector(({ app: { splash, loading }}) => ({ splash, loading}))
    const { backgroundColor, contentColor, iconsColor, buttonColor, cardColor } = useSelector(({ app: { main }}) => main)

    const onSubmit = () => dispatch(onAppSubmit())

    return (
        <Loading loading={loading}>
            <div className="mx-12 mt-5">
                <div className="flex justify-between items-end">
                    <div className="text-2xl font-bold w-1/3">4. {t('Preview')}</div>
                    <div className="w-52 mb-2 w-1/3">
                        <div className="text-center">{t('Step')} 4 of 4</div>
                        <div>
                            <div className="h-3 relative max-w-xl rounded-full overflow-hidden">
                                <div className="w-full h-full bg-gray-200 absolute" />
                                <div className="h-full bg-indigo-600 absolute" style={{width:'100%'}} />
                            </div>
                        </div>
                    </div>
                    <div className="flex w-1/3 justify-end">
                        <Link to={'/chain/app?step=3'}>
                            <Button color={BtnColor.gray} className="ml-2 px-10">{t('Back')}</Button>
                        </Link>
                        <Button onClick={onSubmit} color={BtnColor.indigo} className="ml-2 px-10">{t('Publish')}</Button>
                    </div>
                </div>
                <div className="w-1/2 mt-5">
                    {t('Well done you have created your very own branded app! Please review your design and details before submitting.')}
                </div>
                <div className="flex mt-10">

                    <div className="w-1/2 bg-gray-100 flex justify-center p-5">
                        <EmulatorSplashScreen header={splash.header}
                                              body={splash.body}
                                              backgroundImage={splash.backgroundImage}
                                              headerFont={splash.headerFont}
                                              bodyFont={splash.bodyFont}
                                              backgroundColor={splash.backgroundColor}
                                              textColor={splash.textColor} />
                    </div>

                    <div className="w-1/2 bg-gray-100 flex justify-center p-5">
                        <EmulatorMainScreen
                            backgroundColor={backgroundColor}
                            contentColor={contentColor}
                            iconsColor={iconsColor}
                            buttonColor={buttonColor}
                            cardColor={cardColor} />
                    </div>

                </div>
            </div>
        </Loading>
    )
}

export default Step4
